import { render, staticRenderFns } from "./confirmation-modal.vue?vue&type=template&id=a67d6b2a&scoped=true&"
import script from "./confirmation-modal.vue?vue&type=script&lang=js&"
export * from "./confirmation-modal.vue?vue&type=script&lang=js&"
import style0 from "./confirmation-modal.vue?vue&type=style&index=0&id=a67d6b2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a67d6b2a",
  null
  
)

export default component.exports